<template>
  <div class="zcontainer" v-if="gallery">
    <div class="sub-header">
      <div class="columns sub-header-columns">
        <div class="column">
          <div class="flex">
            <router-link to="/">
              <img src="../assets/findupix-logo-svg.svg" class="brand" />
            </router-link>
            <h1 class="title">Participantes en {{ gallery.name }}</h1>
          </div>
        </div>
      </div>
      <div class="stats">
        <span class="tag is-primary">
          {{ realParticipants.length }} participantes</span
        >
        <span
          class="tag is-warning"
          v-if="!participantsToUploadError && participantsToUpload.length > 0"
        >
          {{ participantsToUpload.length }} participantes preparados para
          subir</span
        >
        <span class="tag is-danger" v-if="participantsToUploadError">
          hay errores en los participantes preparados para subir</span
        >
      </div>
    </div>

    <section id="gallery" v-if="gallery" class="container">
      <p class="help">
        Desde aquí podrá subir los participantes que podrán comprar fotos a
        través del portal. Un participante en cada linia, en este formato: email;dorsal
      </p>
      <p class="help more-help">
        email1@ejemplo.com;150<br />
        email2@ejemplo.com;151<br />
        email3@ejemplo.com;23<br />
        email4@ejemplo.com;2305
      </p>
      <textarea class="textarea" v-model="csv" @input="csvChanged"> </textarea>
      <button
        :disabled="uploading || participantsToUploadError || userProfile.role !== 'admin'"
        @click="upload"
        class="button is-primary mt-4"
      >
        Subir participantes
      </button>
      <br />
      <button
        :disabled="uploading || userProfile.role !== 'admin'"
        @click="deleteAll"
        class="button is-danger mt-4"
      >
        Borrar todos
      </button>

      <!-- <pre>
        {{realParticipants}}
      </pre> -->

      <v-data-table
        :headers="headers"
        :items="realParticipants"
        :footer-props="{
          'items-per-page-options': [50, 100, 150, 200, -1],
        }"
        :items-per-page="50"
        class="elevation-1 mt-5"
      >
        <template v-slot:[`item.actions`]="{ item }">     
          <i
            class="material-icons delete-btn clickable"
            v-on:click="deleteOne(item.id)"
            >delete</i>
        </template>
      </v-data-table>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebase");
import axios from "axios";
import { EventBus } from "../services/event-bus.js";
import { debounce } from "debounce";

export default {
  components: {},
  data() {
    return {
      gallery: {},
      // galleriesArray: [],
      uploaded: 0,
      csv: "",
      participantsToUpload: [],
      participantsToUploadError: false,
      realParticipants: [],
      uploading: false,
      headers: [
        { text: "Email", value: "email" },        
        { text: "Dorsal", value: "number" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState(["userProfile", "galleries"]),
  },
  mounted() {
    if (this.$route.params.id) {
      this.galleryId = this.$route.params.id;
      this.viewGallery();
      this.viewParticipants();

      EventBus.$on("file-uploaded", (fileInfo) => {
        //this.reloadImageView();
        // this.tableView = true
      });
    }
  },
  methods: {
    viewGallery() {
      fb.galleriesCollection
        .doc(this.galleryId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.gallery = doc.data();
            this.gallery.id = this.galleryId;
            this.galleryName = this.gallery.name;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async viewParticipants() {
      fb.participantsCollection
        .where("galleryId", "==", this.galleryId)
        .onSnapshot((snapshot) => {
          let realParticipants = [];

          snapshot.forEach((doc) => {
            let p = doc.data();
            p.id = doc.id;
            realParticipants.push(p);
          });

          //store.commit('setImages', imagesArray)
          this.realParticipants = realParticipants;
        });
    },
    onUploaded(info) {
      //console.log("onUploaded info", info);
    },
    subscribeToChanges() {
      EventBus.$on("file-uploaded", (fileInfo) => {
        //this.reloadImageView();
        this.uploaded++;
      });
    },
    csvChanged() {
      this.participantsToUpload = [];
      try {
        const participantsToUpload = this.csv.split("\n");
        for (var i = 0; i < participantsToUpload.length; i++) {
          const participant = participantsToUpload[i].split(";");
          const participantOk = {
            email: participant[0].trim().toLowerCase(),
            number: participant[1].trim(),
          };
          this.participantsToUpload.push(participantOk);
        }
        // console.log('participants', this.participantsToUpload)
        this.participantsToUploadError = false;
      } catch {
        this.participantsToUpload = [];
        this.participantsToUploadError = true;
      }
    },
    async upload() {
      this.uploading = true;
      for (var i = 0; i < this.participantsToUpload.length; i++) {
        const p = this.participantsToUpload[i];
        const participant = {
          createdOn: new Date(),
          email: p.email,
          number: p.number,
          userId: fb.auth.currentUser.uid,
          galleryId: this.galleryId,
        };
        await fb.participantsCollection.add(participant);
      }
      this.uploading = false;
      this.csv = "";
      this.participantsToUpload = [];
      // this.viewParticipants();
    },
    async deleteAll() {
      const result = await this.$swal({
        title: "¿Eliminar todos?",
        text: `¿Está seguro de borrar los participantes en esta carrera?`,
        icon: "question",
        confirmButtonText: "Sí",
        showCancelButton: true,
        cancelButtonText: "No",
      });

      if (result.value) {
        this.uploading = true;
        fb.participantsCollection
          .where("galleryId", "==", this.galleryId)
          .get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(async function (doc) {
              await doc.ref.delete();
            });
          });
        this.uploading = false;
        this.csv = "";
        this.participantsToUpload = [];
      }
    },
    async deleteOne(id) {
      const result = await this.$swal({
        title: "¿Borrar participante?",
        text: `¿Está seguro de borrar el participante?`,
        icon: "question",
        confirmButtonText: "Sí",
        showCancelButton: true,
        cancelButtonText: "No",
      });

      if (result.value) {
        this.uploading = true;
        const res = await fb.participantsCollection.doc(id).delete();
        this.uploading = false;
      }
    }
  },
};
</script>
<style scoped>
.brand {
  width: calc(100px + 0.5rem);
  margin-left: -0.5rem;
  margin-top: 4px;
}
.title {
  margin-top: 1.1rem;
  margin-left: 1rem;
}
.card-image {
  max-height: 200px;
  width: 100%;
}
.card {
  font-size: 0.85rem;
  border: 2px solid transparent;
  position: relative;
}
.card-text {
  padding: 0.5rem;
}
.gallery {
  margin-top: 1rem;
}
.card:hover {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.2);
}
.buttons {
  margin-top: 1.5rem;
  text-align: right;
}
.buttons i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}
.card-selected {
  border: 2px solid #3298dc;
}
.input {
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid hsl(0, 0%, 71%);
  outline: none;
  font-size: 1.5rem;
}
.input:focus,
.input:active {
  border-bottom: 2px solid hsl(171, 100%, 41%);
  outline: none;
  box-shadow: none;
}
.stats {
  color: #6c757d;
  margin-bottom: 1rem;
}
.stats .tag {
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
}
.stats .tag.tag-selected {
  font-weight: bold;
}
.tag-circle {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  opacity: 0.9;
}
.tag-circle i {
  font-size: 16px;
}
</style>
<style>
.v-data-table-header th.sortable {
  padding-top: 12px !important;
}
.v-data-table table tbody tr td {
  padding-top: 14px !important;
  color: #6c757d !important;
  cursor: pointer;
  font-size: 0.85rem !important;
}
.row-v-data-table {
  padding-bottom: 2rem !important;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding-top: 8px !important;
}
.sub-header {
  position: fixed;
  width: 100%;
  top: 0px;
  border-bottom: 2px solid #eee;
  z-index: 10;
  background-color: #fff;
  left: 0;
  padding: 0 1.5rem;
}
#gallery {
  margin-top: 160px;
}
.pager {
  font-size: 30px;
}
.pager.disabled {
  color: #ccc;
}
.flex {
  display: flex;
}
.search-input {
  display: inline-block;
  width: 150px;
  box-shadow: none;
  font-size: 0.8rem !important;
  padding: 0 4px;
}
.help {
  color: #666;
}
.more-help {
  color: #999;
}
</style>